import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ModalBox from "components/Modal/ModalBox";
import MatchModalContent from "components/CandidateProfileModalContent/MatchModalContent";

const EsaiScore = ({ data, jobInfo, apiRef }) => {
  const { t } = useTranslation();
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [candidateData, setCandidateData] = useState(null);
  const [jopData, setJobData] = useState(null);

  const handleShowMatchModal = (e, data) => {
    setCandidateData(data)
    setJobData(jobInfo ? jobInfo : {
      position_name: data.app_position.position_name,
      position_name_ja: data.app_position.position_name_ja,
      role: data.app_position.role,
      first_targeted: data.first_targeted,
      last_targeted: data.last_targeted
    })
    setShowMatchModal(true);
  }

  const handleCloseMatchModal = () => {
    setShowMatchModal((current) => !current);
  }
  

  return (
    <>
      <div className="card mb-4">
        <div className="card-body">
          <Row>
            <Col sm={3}>
              <div className="mb-0 profile_subsection-dim_title">
                ESAI Score:
              </div>
            </Col>
            <Col sm={3}>
              <div className="mb-0 esai-score-body">
                {data.esai_score}
              </div>
            </Col>
            <Col sm={3}>
              <div className="mb-0 profile_subsection-dim_title">
                ESAI Match:
              </div>
            </Col>
            <Col sm={3}>
              {
                data.esai_match ? (
                  <Link onClick={(e) => handleShowMatchModal(e, data)}>
                    View
                  </Link>
                ) : ""
              }
            </Col>
          </Row>
        </div>
      </div>
      <ModalBox
        show={showMatchModal}
        onHide={handleCloseMatchModal}
        content={
          apiRef?.current?.state && (
            <MatchModalContent
              isCandidatesAccess
              closeModal={handleCloseMatchModal}
              candidateSelected={candidateData}
              jobInfo={jopData}
              title={t("performanceReportText.candidateMatchDetails")}
              apiRef={apiRef}
            />
          )
        }
      />
    </>
  )
}

export default EsaiScore;
